import styled from 'styled-components';
import { PriceConcept } from '@app/src/common/PriceConcept';
import { Button } from '@app/src/common/Button';
import ReCAPTCHA from 'react-google-recaptcha';
import { SIZE } from '@app/src/ui';

interface Props {
    fixed?: boolean;
    isDisplay?: boolean;
  }

export const PriceConceptWrapper = styled(PriceConcept)`
  margin: 10px 0 10px;
  display: none;
  ${(props: Props) => props.isDisplay && `
    display: flex;
  `}
`;

export const ButtonActionsWrapper = styled.div`
  ${(props: Props) => props.fixed &&
    `
      position: fixed;
      z-index: 1000;
      width: 100%;
      bottom: 0;
      padding: 8px 15px;
      background: #fff;
      margin-left: -15px;
    `
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-bottom: 15%;
  }
`;

export const ButtonPrevWrapper = styled(Button)`
  height: 44px;
  font-size: 12px;
  font-weight: 600;
  svg {
    flex: 0 0 auto;
    margin-right: 6px;
  }
  span {
    text-align: left;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 55px;
    font-size: 14px;
  }
`;

export const ButtonNextWrapper = styled(Button)`
  height: 44px;
  font-size: 14px;
  font-weight: 600;
  svg {
    transform: rotate(180deg);
    margin-left: 6px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 55px;
    font-size: 16px;
  }
`;

export const RecaptchaWrapper = styled.div`
  max-width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  opacity: .5;
`;

export const Recaptcha = styled(ReCAPTCHA)`
  transform-origin: 0 0;
  transform: scale(0.8) translateX(10%);
`;

export const Wrapper = styled.div`
  margin-top: auto;
`;